import React, { createContext, useContext, useState, useEffect } from "react";
import { api } from "@/lib/api";

const ConfigContext = createContext();

export function ConfigProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/settings/public");
        setSettings(data);
      } catch (e) {
        console.error("Failed to fetch system settings", e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <ConfigContext.Provider value={{ settings, loading }}>
      {children}
    </ConfigContext.Provider>
  );
}

export const useConfig = () => useContext(ConfigContext);
